import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@app/core/auth';
import {
	NbIconModule,
	NbMediaBreakpointsService,
	NbThemeService
} from '@nebular/theme';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
	selector: 'app-user-action',
	styleUrls: ['./user.component.scss'],
	templateUrl: './user.component.html',
	standalone: true,
	imports: [NbIconModule, TranslateModule]
})
export class UserActionComponent implements OnInit {
	showUserText = false;

	/**
	 * DI
	 */
	private userService = inject(UserService);
	private themeService = inject(NbThemeService);
	private breakpointService = inject(NbMediaBreakpointsService);
	private router = inject(Router);

	get userName(): string {
		return `${this.userService.user?.Nome} ${this.userService.user?.Cognome} `;
	}

	ngOnInit() {
		const { xl } = this.breakpointService.getBreakpointsMap();
		this.themeService
			.onMediaQueryChange()
			.pipe(
				map(([, currentBreakpoint]) => currentBreakpoint),
				untilDestroyed(this)
			)
			.subscribe(brakpoint => {
				if (brakpoint.width < xl) {
					this.showUserText = false;
				} else {
					this.showUserText = true;
				}
			});
	}

	navigateTo(link: string) {
		this.router.navigate([link]);
	}

	// logout(): void {
	//   // this.authService.logout();
	//   this.router.navigate(['/auth/logout']);
	// }
}
